import { Autocomplete, Box, Checkbox, Collapse, FormControl, FormControlLabel, Grid, IconButton, InputLabel, MenuItem, Select, TextField, Typography, useMediaQuery, useTheme } from '@mui/material'
import { t } from 'i18next'
import React, { useState } from 'react'
import { TQualifyChoices } from '../../shared/types/qualifyChoices.type'
import { TQualifyData } from '../modals/EditTrainingsModal'
import { TTrainingType } from '../../shared/types/training.type'
import { sortBy } from 'lodash'
import { Ttrack } from '../../shared/types/tracks.type'
import ListSkeleton from '../exams/loader/ListSkeleton'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
type GlobalEditorProps = {
    qualifyChoices: TQualifyChoices | null,
    onChangeSelect: (key: keyof TQualifyData, value?: string) => void,
    qualifyData: TQualifyData,
    onToggleExams: (checked: boolean) => void,
    isVisible: boolean,
    loading: boolean,
}
function GlobalEditor({ qualifyChoices, onChangeSelect, qualifyData, onToggleExams, isVisible, loading }: GlobalEditorProps) {

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md")); // Check if screen is "sm" or smaller

    const [toggleView, setToogleView] = useState(false)



    if (loading) {
        return <ListSkeleton length={5} height={50} stackProps={{ direction: 'row', spacing: 2 }} />
    }

    if (!qualifyChoices) {
        return null
    }

    return (
        <Grid container spacing={2}>
            <Grid item md={2} sm={12} xs={12} sx={{ placeSelf: 'center' }}>
                <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                    {
                        isVisible ?
                            <FormControlLabel control={<Checkbox indeterminate onChange={(_, checked) => onToggleExams(false)} />} label={t('editTrainingForm:forTheSelection')}></FormControlLabel>
                            : <Typography sx={{ alignSelf: 'center' }} variant='body2'>{t('editTrainingForm:forTheSelection')}</Typography>

                    }
                    {
                        isSmallScreen && <IconButton onClick={() => setToogleView(!toggleView)}>
                            {toggleView ? <ExpandLess /> : <ExpandMore />}
                        </IconButton>
                    }


                </Box>

            </Grid>
            <Grid item md={10} sm={12} xs={12} >
                <Collapse in={!isSmallScreen ? true : toggleView}>
                    <Grid container spacing={2}>
                        <Grid item md={2.5} sm={12} xs={12}>
                            {/* Training Type */}
                            <FormControl fullWidth>
                                <Autocomplete
                                    options={sortBy(qualifyChoices.training_types, i => i.display_name)}
                                    id="demo-simple-select"
                                    getOptionLabel={e => e.display_name}
                                    getOptionKey={e => e['@id']}
                                    value={qualifyChoices.training_types?.find(e => e['@id'] === qualifyData.training_types)}
                                    onChange={(e, value) => { onChangeSelect('training_types', value?.['@id']) }}
                                    renderInput={(params) => <TextField {...params} label={t('editTrainingForm:trainingType:label')} />}

                                />
                            </FormControl>
                        </Grid>

                        {/* Track */}
                        <Grid item md={2.5} sm={12} xs={12}>

                            <FormControl fullWidth>
                                <Autocomplete
                                    id="track_names"
                                    options={sortBy(qualifyChoices.track_names, i => i.display_name)}
                                    getOptionLabel={(option) => option?.display_name ?? ''}
                                    value={
                                        qualifyChoices.track_names?.find(
                                            (e) => e['@id'] === qualifyData.track_names
                                        ) || null
                                    }
                                    isOptionEqualToValue={(option, value) =>
                                        option['@id'] === value['@id']
                                    }
                                    onChange={(e, value) => onChangeSelect('track_names', value?.['@id'])}
                                    renderInput={(params) => (
                                        <TextField {...params} label={t('editTrainingForm:trackName:label')} />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        {/* Track surface */}
                        <Grid item md={2} sm={12} xs={12}>

                            <FormControl fullWidth>
                                <Autocomplete
                                    options={sortBy(qualifyChoices.track_surfaces, i => i.display_name)}
                                    id="demo-simple-select"
                                    key={qualifyData.track_surfaces}
                                    getOptionLabel={e => e.display_name}
                                    getOptionKey={e => e['@id']}
                                    value={qualifyChoices?.track_surfaces?.find(e => e['@id'] === qualifyData.track_surfaces)}
                                    onChange={(e, value) => { onChangeSelect('track_surfaces', value?.['@id']) }}
                                    renderInput={(params) => <TextField {...params} label={t('editTrainingForm:trackSurface:label')} />}

                                />

                            </FormControl>
                        </Grid>

                        {/* Track condition */}
                        <Grid item md={2.5} sm={12} xs={12}>
                            <FormControl fullWidth>
                                <Autocomplete
                                    options={sortBy(qualifyChoices.track_conditions, i => i.display_name)}
                                    id="demo-simple-select"
                                    getOptionLabel={e => e.display_name}
                                    getOptionKey={e => e['@id']}
                                    value={qualifyChoices.track_conditions?.find(e => e['@id'] === qualifyData.track_conditions)}
                                    onChange={(e, value) => { onChangeSelect('track_conditions', value?.['@id']) }}
                                    renderInput={(params) => <TextField {...params} label={t('editTrainingForm:trackCondition:label')} />}

                                />

                            </FormControl>
                        </Grid>
                        {/* Riedr name */}
                        <Grid item md={2.5} sm={12} xs={12}>
                            <FormControl fullWidth>
                                <Autocomplete
                                    options={sortBy(qualifyChoices.riders, i => i.display_name)}
                                    id="demo-simple-select"
                                    getOptionLabel={e => e.display_name}
                                    getOptionKey={e => e['@id']}
                                    value={qualifyChoices.riders?.find(e => e['@id'] === qualifyData.riders)}
                                    onChange={(e, value) => { onChangeSelect('riders', value?.['@id']) }}
                                    renderInput={(params) => <TextField {...params} label={t('editTrainingForm:riderName:label')} />}

                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                </Collapse>
            </Grid>
        </Grid >
    )
}

export default GlobalEditor